import { P2GBox, useTheme, P2GGrid, P2GTooltip, P2GText } from '@parcel2go/core-ui';
import { Fragment, useMemo } from 'react';
import { TrackingSummaryApiModel } from '~/lib/api/smartsend/types';
import CalculateLatestTrackingStep from './CalculateLatestTrackingStep';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  tracking: TrackingSummaryApiModel;
  isDropOff?: boolean;
}

const TrackingSpacer = () => <div style={{ height: '10px', width: '3px' }}></div>;

const TrackingStage = (props: { latestStageNumber: number; stage: number }) => {
  const theme = useTheme();
  return (
    <P2GBox backgroundColour={props.latestStageNumber >= props.stage ? theme.palette.success.main : '#f1f1f1'}>
      <TrackingSpacer />
    </P2GBox>
  );
};

const TrackingStageLabel = (props: { latestStatus: string; isDropOff?: boolean; stage: number }) => {
  const { t } = useTranslation(TranslationNamespaces.MYORDERS);

  // Basic messaging - needs expanding.
  const label = useMemo(() => {
    if (props.latestStatus === 'Created' || props.latestStatus === 'New' || !props.latestStatus) {
      return props.isDropOff === true
        ? t('TRACKING_STATUS_AWAITING_DROPOFF_LABEL', { defaultValue: 'Awaiting Drop Off' })
        : t('TRACKING_STATUS_AWAITING_COLLECTION_LABEL', { defaultValue: 'Awaiting Collection' });
    }

    return t(`TRACKING_STATUS_${props.latestStatus.toUpperCase()}_LABEL`, { defaultValue: props.latestStatus });
  }, [props.latestStatus, props.isDropOff, t]);

  return (
    <P2GText variant="caption">
      <strong>{t('TRACKING_STATUS_LATEST_LABEL', { defaultValue: 'Tracking Status' })}:</strong> {label}
    </P2GText>
  );
};

export default function TrackingProgress(props: props) {
  const { t } = useTranslation(TranslationNamespaces.MYORDERS);
  const latestStageNumber = useMemo<number>(() => CalculateLatestTrackingStep(props.tracking), [props.tracking]);
  const steps = [1, 2, 3, 4, 5];
  return (
    <P2GTooltip
      title={props.tracking?.LatestStatus || t('TRACKING_STATUS_LATEST_LABEL', { defaultValue: 'Tracking Status' })}
      children={
        <div style={{ overflow: 'hidden', borderRadius: '5px' }}>
          <P2GGrid container justify="space-evenly" alignItems="center" alignContent="center">
            {steps.map((stage) => (
              <Fragment key={`${stage}`}>
                {stage > 1 && (
                  <P2GGrid item flexShrink={1}>
                    <TrackingSpacer />
                  </P2GGrid>
                )}
                <P2GGrid item flexGrow={1}>
                  <TrackingStage latestStageNumber={latestStageNumber} stage={stage} />
                </P2GGrid>
              </Fragment>
            ))}
          </P2GGrid>
          <P2GBox pt={0.5}>
            <TrackingStageLabel
              latestStatus={props.tracking?.LatestStatus}
              isDropOff={props.isDropOff}
              stage={latestStageNumber}
            />
          </P2GBox>
        </div>
      }
    />
  );
}
